export enum NoCostLoginMethod {
  Biometrics = 1,
  QuickLogin = 2,
  Password = 3,
}

export enum NoCostLoginOperation {
  enable = 'enable',
  disable = 'disable',
}
